module.exports = __webpack_public_path__ + "static/img/gnmk_1@2x.b664da82.png";